// extracted by mini-css-extract-plugin
module.exports = {"container":"MSelect_container__DpKKP","btnContent":"MSelect_btnContent__2Qvhr","text":"MSelect_text__WC3UF","chevron":"MSelect_chevron__hpQU3","list":"MSelect_list__JvafG"};